import React, { useState, useEffect, useCallback } from "react";
import Navbar from "./Navbar";
import axios from "axios";
import url from "../../function/url";
import Cookies from "js-cookie";

function MembershipCompany() {
  const ID = Cookies.get("log_id");

  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null); 
  const [showModalPayment, setShowModalPayment] = useState(false);
  const [showModalRejection, setShowModalRejection] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [rejectionReason, setRejectionReason] = useState("");

  const fetchCompanies = useCallback(
    async (pageUrl = `${url.path}/telecaller-details/`) => {
      try {
        const response = await axios.get(pageUrl, { params: { login_id: ID } });
        console.log(response.data);
        setCompanies(response.data.companies);
        setFilteredCompanies(response.data.companies);
        setNextPage(response.data.next);
        setPrevPage(response.data.previous);
      } catch (error) {
        console.error("Error fetching companies:", error);
        setCompanies([]);
        setFilteredCompanies([]);
      }
    },
    [ID]
  );

  useEffect(() => {
    if (ID) {
      fetchCompanies();
    }
  }, [ID, fetchCompanies]);

  // Function to handle payment submission
  const handlePayment = async () => {
    if (!selectedCompany || !selectedCompany.id) {
      alert("Please select an company before proceeding with the payment.");
      return;
    }

    const companyPayment = paymentDetails[selectedCompany.id];

    if (!companyPayment?.method || !companyPayment?.amount) {
      alert("Payment method and amount are required.");
      return;
    }

    try {
      const response = await axios.patch(`${url.path}/process-payment/`, {
        login_id: ID,
        company_id: selectedCompany.id,
        payment_method: companyPayment.method,
        amount: companyPayment.amount,
        payment_info: companyPayment.info || "",
      });
      console.log("Payment response:", response.data);
      alert(`Payment successful via ${companyPayment.method}`);
      //new statemnt
      setCompanies((prevCompanies) =>
        prevCompanies.map((cmp) =>
          cmp.id === selectedCompany.id
            ? {
                ...cmp,
                payment_method: companyPayment.method,
                payment_amount: companyPayment.amount,
                payment_info: companyPayment.info || "",
              }
            : cmp
        )
      );
      
      setShowModalPayment(false);
      setPaymentDetails((prev) => ({
        ...prev,
        [selectedCompany.id]: { method: "", amount: "", info: "" },
      }));
    } catch (error) {
      console.error("Payment failed:", error);

      const errorMessage =
        error.response?.data?.message || "Payment failed. Please try again.";
      alert(errorMessage);
    }
  };

  const handleStatusChange = async (companyId, newStatus) => {
    console.log("newstatus",newStatus)
    console.log(companyId)
    // new statment
    const company = companies.find((cmp) => cmp.id === companyId);
    if (newStatus === "Approved") {
      if (
        !company.payment_method || 
        !company.payment_amount
      ) {
        alert("Please complete the payment before approving.");
        return;
      }
    }

    try {
      await axios.patch(`${url.path}/update-MembershipEmployeeCompany/`, {
        login_id: ID,
        company_id: companyId,
        status: newStatus,
      });
      
      setCompanies((prevCompanies) =>
        prevCompanies.map((cmp) =>
          cmp.id === companyId ? { ...cmp, status: newStatus } : cmp
        )
      );
      setFilteredCompanies((prevCompanies) =>
        prevCompanies.map((cmp) =>
          cmp.id === companyId ? { ...cmp, status: newStatus } : cmp
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  // Function to handle rejection (opens modal)
  const handleReject = (company) => {
    setSelectedCompany(company);
    setShowModalRejection(true);
  };

  // Function to submit rejection reason
  const submitRejection = async () => {
    if (!rejectionReason.trim()) {
      alert("Please enter a rejection reason.");
      return;
    }

    try {
      await axios.delete(`${url.path}/update-MembershipEmployeeCompany/`, {
        data: {
          login_id: ID,
          company_id: selectedCompany.id,
          reason: rejectionReason,
        },
      });

      setCompanies((prevCompanies) =>
        prevCompanies.map((cmp) =>
          cmp.id === selectedCompany.id
            ? {
                ...cmp,
                status: "Rejected",
                reasonForRejection: rejectionReason,
              }
            : cmp
        )
      );

      setFilteredCompanies((prevCompanies) =>
        prevCompanies.map((cmp) =>
          cmp.id === selectedCompany.id
            ? {
                ...cmp,
                status: "Rejected",
                reasonForRejection: rejectionReason,
              }
            : cmp
        )
      );

      setShowModalRejection(false);
      setRejectionReason("");
    } catch (error) {
      console.error("Error rejecting employee:", error);
    }
  };

  return (
    <div>
      <Navbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Membership
        </h3>
      </center>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
        }}
      >
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => {
            const value = e.target.value.toLowerCase();
            setSearchTerm(value);
            // const filtered = companies.filter(
            //   (cmp) =>
            //     cmp.name.toLowerCase().includes(value) ||
            //     cmp.email.toLowerCase().includes(value) ||
            //     cmp.contact.toLowerCase().includes(value)
            // );
            const filtered = companies.filter((cmp) =>
              (cmp.name?.toLowerCase() || "").includes(value) ||
              (cmp.email?.toLowerCase() || "").includes(value) ||
              (cmp.contact?.toLowerCase() || "").includes(value)
            );
            setFilteredCompanies(filtered);
          }}
          placeholder="Search by name, email, or contact..."
          className="search-input"
          style={{
            width: "250px",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            textAlign: "center",
          }}
        />
      </div>

      <div className="table-container">
        <table className="responsive-table" id="productstable">
          <thead className="bg-gray-200">
            <tr>
              <th className="border border-gray-300 px-4 py-2">Company Name</th>
              <th className="border border-gray-300 px-4 py-2">Email</th>
              <th className="border border-gray-300 px-4 py-2">
                Package Taken
              </th>
              <th className="border border-gray-300 px-4 py-2">Payment</th>
              <th className="border border-gray-300 px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredCompanies && filteredCompanies.length > 0 ? (
              filteredCompanies.map((company) => (
                <tr key={company.id}>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.name}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.email}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.package_taken}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <button
                      onClick={() => {
                        setSelectedCompany(company);
                        setShowModalPayment(true);
                      }}
                    //   className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-700"
                    // >
                    className={`px-4 py-2 text-white rounded-md ${
                      company.status === "Approved" || company.status === "Rejected"
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-green-500 hover:bg-green-700"
                    }`}
                    disabled={company.status === "Approved" || company.status === "Rejected"}
                  >
                      Pay
                    </button>
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.status === "Approved" ? (
                      <button className="px-4 py-2 bg-green-500 text-white rounded-md cursor-not-allowed">
                        Approved
                      </button>
                    ) : company.status === "Rejected" ? (
                      <button className="px-4 py-2 bg-red-500 text-white rounded-md cursor-not-allowed">
                        Rejected
                      </button>
                    ) : (
                      <>
                        <button
                          onClick={() =>
                            handleStatusChange(company.id, "Approved")
                          }
                          className="px-2 py-1 bg-blue-500 text-white rounded-md mx-1 hover:bg-blue-700"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() => handleReject(company)}
                          className="px-2 py-1 bg-red-500 text-white rounded-md mx-1 hover:bg-red-700"
                        >
                          Reject
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-2">
                  No companies found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Payment */}
      {showModalPayment && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-bold mb-4">
              Select Payment Method for {selectedCompany?.name}
            </h2>

            <select
              value={paymentDetails[selectedCompany?.id]?.method || ""}
              onChange={(e) =>
                setPaymentDetails((prev) => ({
                  ...prev,
                  [selectedCompany.id]: {
                    ...prev[selectedCompany.id],
                    method: e.target.value,
                    info: "",
                  },
                }))
              }
              className="w-full p-2 border rounded-md mb-3"
            >
              <option value="">Select Payment Method</option>
              <option value="UPI">UPI</option>
              <option value="Cash">Cash</option>
              <option value="Bank Transfer">Bank Transfer</option>
              <option value="Cheque">Cheque</option>
            </select>

            <input
              type="number"
              placeholder="Enter Amount"
              value={paymentDetails[selectedCompany?.id]?.amount || ""}
              onChange={(e) =>
                setPaymentDetails((prev) => ({
                  ...prev,
                  [selectedCompany.id]: {
                    ...prev[selectedCompany.id],
                    amount: e.target.value,
                  },
                }))
              }
              className="w-full p-2 border rounded-md mb-3"
            />

            {paymentDetails[selectedCompany?.id]?.method === "UPI" && (
              <input
                type="text"
                placeholder="Enter UPI Number"
                value={paymentDetails[selectedCompany?.id]?.info || ""}
                onChange={(e) =>
                  setPaymentDetails((prev) => ({
                    ...prev,
                    [selectedCompany.id]: {
                      ...prev[selectedCompany.id],
                      info: e.target.value,
                    },
                  }))
                }
                className="w-full p-2 border rounded-md mb-3"
              />
            )}
            {paymentDetails[selectedCompany?.id]?.method ===
              "Bank Transfer" && (
              <input
                type="text"
                placeholder="Enter Bank Account Number"
                value={paymentDetails[selectedCompany?.id]?.info || ""}
                onChange={(e) =>
                  setPaymentDetails((prev) => ({
                    ...prev,
                    [selectedCompany.id]: {
                      ...prev[selectedCompany.id],
                      info: e.target.value,
                    },
                  }))
                }
                className="w-full p-2 border rounded-md mb-3"
              />
            )}
            {paymentDetails[selectedCompany?.id]?.method === "Cheque" && (
              <input
                type="text"
                placeholder="Enter Cheque Number"
                value={paymentDetails[selectedCompany?.id]?.info || ""}
                onChange={(e) =>
                  setPaymentDetails((prev) => ({
                    ...prev,
                    [selectedCompany.id]: {
                      ...prev[selectedCompany.id],
                      info: e.target.value,
                    },
                  }))
                }
                className="w-full p-2 border rounded-md mb-3"
              />
            )}

            <div className="flex justify-end mt-4">
              <button
                onClick={() => setShowModalPayment(false)}
                className="px-4 py-2 bg-gray-400 text-white rounded-md mx-2 hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                onClick={() => handlePayment(selectedCompany.id)}
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-700"
                disabled={
                  !paymentDetails[selectedCompany?.id]?.amount ||
                  (!paymentDetails[selectedCompany?.id]?.info &&
                    paymentDetails[selectedCompany?.id]?.method !== "Cash")
                }
              >
                Confirm Payment
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Rejection Modal */}

      {showModalRejection && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-5 rounded-md shadow-lg w-96">
            <h2 className="text-lg font-bold mb-2">Reason for Rejection</h2>
            <textarea
              className="w-full p-2 border rounded-md"
              rows="3"
              placeholder="Enter rejection reason"
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
            ></textarea>
            <div className="flex justify-end mt-3">
              <button
                onClick={() => setShowModalRejection(false)}
                className="px-4 py-2 bg-gray-500 text-white rounded-md mx-2 hover:bg-gray-700"
              >
                Cancel
              </button>
              <button
                onClick={submitRejection}
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-700"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-center mt-4">
        {prevPage && (
          <button
            onClick={() => fetchCompanies(prevPage)}
            className="px-4 py-2 bg-gray-500 text-white rounded-md mx-2 hover:bg-gray-700"
          >
            Previous
          </button>
        )}
        {nextPage && (
          <button
            onClick={() => fetchCompanies(nextPage)}
            className="px-4 py-2 bg-blue-500 text-white rounded-md mx-2 hover:bg-blue-700"
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
}

export default MembershipCompany;
